import { useEffect } from "react";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { useAuthStore } from "@/store/authStore";

const AuthLayout = () => {
	const { isLoggedIn, isTokenChecked } = useAuthStore();
	const navigate = useNavigate();

	useEffect(() => {
		// Only redirect if token has been checked and user is not logged in
		if (isTokenChecked && !isLoggedIn) {
			navigate({ to: "/login" });
		}
	}, [isLoggedIn, isTokenChecked, navigate]);

	// Show loading while checking token
	if (!isTokenChecked) {
		return (
			<div className="flex h-screen items-center justify-center">
				<div className="text-center">
					<div className="mb-4 text-2xl font-bold">PhilTrade</div>
					<div className="text-lg">Loading...</div>
				</div>
			</div>
		);
	}

	// Don't render anything if not logged in (will redirect)
	if (!isLoggedIn) {
		return null;
	}

	return <Outlet />;
};

export default AuthLayout;
